import { SessionOverviewPanel } from '../SessionOverviewPanel/SessionOverviewPanel';

export const SessionOverviewError = ({ children }: { children: React.ReactNode }) => (
  <SessionOverviewPanel role='alert' aria-live='assertive'>
    <p className='text-text-default-secondary'>{children}</p>
  </SessionOverviewPanel>
);
